// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"gq-z","imageAndVideoCount":"hq-z","imageAndVideoContainer":"iq-z","viewAllReviews":"jq-z"};